// extracted by mini-css-extract-plugin
export default {"amountCell":"PunchupTableBody_amountCell__rqu5u"};